/* Pollyfils */

/**
 * DOM elements closest
 * @see https://developer.mozilla.org/ru/docs/Web/API/Element/closest
 */
(function(ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
        if (!this) return null;
        if (this.matches(selector)) return this;
        if (!this.parentElement) {return null}
        else return this.parentElement.closest(selector)
    };
}(Element.prototype));


if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
  
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
}

if (typeof(bq) === "undefined") { bq = {}; }
if (typeof(bq.callbacks) === "undefined") { bq.callbacks = {}; }
if (typeof(bq.global) === "undefined") { bq.global = {}; }
if (typeof(bq.global.ajaxActions) === "undefined") { bq.global.ajaxActions = {}; }
if (typeof(bq.global.parsley) === "undefined") { bq.global.parsley = {}; }
if (typeof(bq.manage) === "undefined") { bq.manage = {}; }
if (typeof(bq.marketplace) === "undefined") { bq.marketplace = {}; }
if (typeof(bq.init) === "undefined") { bq.init = []; }
if (typeof(bq.elementStorage) === "undefined") { bq.elementStorage = {}; }
if (typeof(bq.isAjaxInProcess) === "undefined") { bq.isAjaxInProcess = false; }